import { useNavigate } from "react-router-dom";
import { PRODUCTS_ROUTES } from "../pages/FlexSetup/constants";
import routes from "components/routes";

const useFlex = () => {
  const navigate = useNavigate();

  const setupListener = () => {
    window.addEventListener("popstate", handleBack);
  }
  const removeListener = () => {
    window.removeEventListener("popstate", handleBack);
  }

  // get list of selected products from local storage
  const getSelectedProductList = () => {
    let selectedProductList = localStorage.getItem("selected_product_list");
    if (selectedProductList) {
      selectedProductList = JSON.parse(selectedProductList);
    }
    return selectedProductList;
  };

  const handleBack = () => {
    if(!getSelectedProductList()) return
    const completedProductList = getCompletedProductList();
    const idx = completedProductList.findIndex(({ routesCompleted, product }) => {
      // route details of the product
      const routesDetails = PRODUCTS_ROUTES[product];
      if (routesCompleted !== routesDetails.length) {
        return true;
      }
    });
    const lastProduct = completedProductList[completedProductList.length - 1];
    if (idx > -1) {
      const newList = [...completedProductList];
      if (newList[idx].routesCompleted === 0 && idx > 0) {
        newList[idx - 1] = {
          ...newList[idx - 1],
          routesCompleted: newList[idx - 1].routesCompleted - 1,
        };
      } else {
        newList[idx] = {
          ...newList[idx],
          routesCompleted: newList[idx].routesCompleted - 1,
        }
      }
      localStorage.setItem(
        "completed_product_list",
        JSON.stringify(newList)
      )
    } else if(lastProduct.routesCompleted === PRODUCTS_ROUTES[lastProduct.product].length) {
      const newList = [...completedProductList];
      newList[newList.length - 1] = {
        ...newList[newList.length - 1],
        routesCompleted: newList[newList.length - 1].routesCompleted - 1,
      }
      localStorage.setItem(
        "completed_product_list",
        JSON.stringify(newList)
      )
    }
  };

  // get list of completed products from local storage
  const getCompletedProductList = () => {
    let completedProductList = localStorage.getItem("completed_product_list");
    if (completedProductList) {
      completedProductList = JSON.parse(completedProductList);
    } else {
      const selectedProductList = getSelectedProductList();
      // initializing completed product list with setup false
      completedProductList = selectedProductList.map((product) => ({
        ...product,
        routesCompleted: 0,
      }));
    }
    localStorage.setItem(
      "completed_product_list",
      JSON.stringify(completedProductList)
    );
    return completedProductList;
  };

  const resetCompletedProductList = () => {
    localStorage.removeItem("completed_product_list");
  };

  /**
   *
   * @param {*} route -> route to navigate to
   * @param {*} params  -> params to pass to the route
   * @param {*} completedProductKey -> key of the product that is completed (if its the last page of the product)
   * @returns
   */
  const next = (params = {}, skip) => {
    const completedProductList = getCompletedProductList();

    const currentProduct = completedProductList.find(
      ({ routesCompleted, product }) => {
        // route details of the product
        const routesDetails = PRODUCTS_ROUTES[product];
        if (routesCompleted < routesDetails.length) {
          return true;
        }
      }
    );

    if (currentProduct) {
      const routes = PRODUCTS_ROUTES[currentProduct.product];
      if (!skip) incrementRoutesCompleted(currentProduct);
      navigate(`/${routes[currentProduct.routesCompleted]}`, {
        state: {
          key: Date.now(),
          ...params,
          product: currentProduct.product,
        },
        replace: true
      });
    } else {
      // redirect to flex dashboard
      localStorage.removeItem('setup_plan_payload');
      navigate(`/${routes.FLEX_MASTER_DOC}`);
    }
  };

  const incrementRoutesCompleted = (currentProduct) => {
    const completedProductList = getCompletedProductList();
    const index = completedProductList.findIndex(
      ({ product }) => product === currentProduct.product
    );
    const newCompletedProductList = [...completedProductList];
    newCompletedProductList[index] = {
      ...newCompletedProductList[index],
      routesCompleted: newCompletedProductList[index].routesCompleted + 1,
    };
    localStorage.setItem(
      "completed_product_list",
      JSON.stringify(newCompletedProductList)
    );
  };

  // get product details from product list
  const getProductDetails = (productKey) => {
    const productList = JSON.parse(localStorage.getItem("product_list"));
    if (!productList) return null;

    const product = productList.find(({ value }) => value === productKey);
    return product;
  };

  /**
   *
   * @param {*} productKey -> key of the product
   * @returns 0 -> if product is Mandatory
   *         1 -> if product is Voluntary
   */
  const getProductType = (productKey) => {
    const productList = JSON.parse(localStorage.getItem("selected_product_list"));
    if (!productList) return null;
    return productList.find(({ product }) => product === productKey).option;
  }

  const reset = (product) => {
    if (product) {
      const completedProductList = getCompletedProductList();
      const index = completedProductList.findIndex(
        ({ product: completedProduct }) => completedProduct === product
      );
      const newCompletedProductList = [...completedProductList];
      newCompletedProductList[index] = {
        ...newCompletedProductList[index],
        setup: false,
      };
      localStorage.setItem(
        "completed_product_list",
        JSON.stringify(newCompletedProductList)
      );
    } else {
      localStorage.removeItem("completed_product_list");
      localStorage.removeItem("selected_product_list");
    }
  };

  return {
    next,
    reset,
    getSelectedProductList,
    getCompletedProductList,
    getProductDetails,
    getProductType,
    resetCompletedProductList,
    setupListener,
    removeListener
  };
};

export default useFlex;
